import { saveAs } from "file-saver";

export const saveFile = (content: Blob, fileName: string) =>
  saveAs(
    new Blob([content], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    fileName
  );
